import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import Steper from "Component/Steper/Steper";
import CurrencyModal from "Component/Modals/CurrencyModal";
import transakSDK, { exclude } from "@transak/transak-sdk";
import CryptoModal from "Component/Modals/CryptoModal ";
import { useDispatch, useSelector } from "react-redux";
import { getPrice, getCurrency, getCrypto, verifyWallet } from "store/actions";
import Detailsbox from "Pages/Buydetails/detailsbox";
import Newsteper from "Component/Steper/newSteper";
import { useKycStatus } from "helpers/custom-hooks";

import { Link, useLocation, useNavigate } from "react-router-dom";

import Processingmodal from "Component/Modals/Processingmodal";
import useToastr from "helpers/toastr";
import Loader from "Component/Common/Loader";
import ButtonLoader from "Component/Common/ButtonLoader";
import { useTranslation } from "react-i18next";
import { tr } from "@lifi/widget/i18n";
import Header from "Component/Header/Header";
import UnirampComponent from "Pages/Uniramp/UnirampComponent";
import Web3 from "web3";

const Buypagestepone = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let exChangeBuy = JSON.parse(localStorage.getItem("exChangeBuy"));

  let lang = localStorage.getItem("lang");

  const isVerified = useKycStatus();

  const [showCurrency, setShowCurrency] = useState(false);
  const [showCrypto, setShowCrypto] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [selectedCrypto, setSelectedCrypto] = useState();
  const [marketPrice, setMarketPrice] = useState(null);
  const [isShowVerification, setIsShowVerification] = useState(false);
  const [isValid, setIsValid] = useState(false);
  let symbol = selectedCurrency?.symbol;
  const toastr = useToastr();
  const [isBuyClicked, setBuyClicked] = useState(false);
  const [isPath, setPath] = useState(location?.pathname);

  const [cryptoValue, setCryptoValue] = useState();
  const [currencyValue, setCurrencyValue] = useState(1);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [filters, setFiters] = useState({
    page: 1,
    limit: 1000,
  });

  let params = {
    fsym: selectedCrypto,
    tsyms: selectedCurrency,
  };

  const [fields, setFields] = useState({
    walletAddress: "",
    termsCondition: "",
    privacyPolicy: "",
  });

  const { currencyList } = useSelector((state) => state?.Currency);
  const { cryptoList } = useSelector((state) => state?.Crypto);
  const { user } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.Price);
  const [isAddressVerified, setAddressVerified] = useState(false);

  const [processingmodal, setProcessingmodal] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  /**
   * Used for open the transak SDK
   */
  function openTransak() {
    const settings = {
      apiKey: user?.keys?.apiKey, // Your API Key
      environment: user?.keys?.mode, // STAGING/PRODUCTION
      themeColor: "#560ab5", // App theme color
      hostURL: window.location.origin,
      widgetHeight: "500px",
      widgetWidth: "500px",
      hideMenu: true,
      isFeeCalculationHidden: false,
      exchangeScreenTitle: "Buy Crypto",
      disableWalletAddressForm: true,
      walletAddress: fields?.walletAddress,
      isAutoFillUserData: true,
      email: user?.email,
      fiatAmount: currencyValue,
      fiatCurrency: selectedCurrency?.symbol,
      cryptoCurrencyCode: selectedCrypto?.mainnet_symbol,
      partnerCustomerId: user?._id,
      productsAvailed: "BUY",
      userData: {
        firstName: user?.fname,
        lastName: user?.lname,
        email: user?.email,
        mobileNumber: user?.mobileNumber,
        countryCode: user?.countryCode,
      },
    };
    const transak = new transakSDK(settings);

    transak.init();

    // To get all the events
    transak.on(transak.ALL_EVENTS, (data) => {});

    // This will trigger when the user closed the widget
    transak.on(transak.EVENTS.TRANSAK_WIDGET_CLOSE, (eventData) => {
      setBuyClicked(false);
      setAddressVerified(false);

      transak.close();
    });

    // This will trigger when the user marks payment is made.
    transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
      // console.log("orderData",orderData)
      // setProcessingmodal(!processingmodal);
      setAddressVerified(false);
      // transak.close();
    });
  }

  useEffect(() => {
    if (exChangeBuy) {
      setCurrencyValue(exChangeBuy?.currencyValue);
      setCryptoValue(exChangeBuy?.cryptoValue);
      setSelectedCurrency(exChangeBuy?.selectedCurrency);
      setSelectedCrypto(exChangeBuy?.selectedCrypto);
      symbol = exChangeBuy?.selectedCurrency?.symbol;
    }
  }, []);

  useEffect(() => {
    if (exChangeBuy == null) {
      if (currencyList?.resdata?.length > 0) {
        setSelectedCurrency(currencyList?.resdata[0]);
        symbol = currencyList?.resdata[0]?.symbol;
      }
    }
  }, [currencyList]);

  useEffect(() => {
    if (exChangeBuy == null) {
      if (cryptoList?.resdata?.length > 0) {
        setSelectedCrypto(cryptoList?.resdata[0]);
        console.log("cryptoList?.resdata[0]?.address" ,cryptoList?.resdata[0]?.address);
        setFields({
          ...fields,
          walletAddress: cryptoList?.resdata[0]?.address,
        });
      }
    } else {
      if (cryptoList?.resdata?.length > 0) {
        const result = cryptoList?.resdata.find(
          (element) => element._id == exChangeBuy?.selectedCrypto?._id
        );

        setFields({
          ...fields,
          walletAddress: result?.address,
        });
      }
    }
  }, [cryptoList,selectedPlatform]);

  useEffect(() => {
    if (cryptoList?.resdata?.length > 0 && currencyList?.resdata?.length > 0) {
      dispatch(
        getPrice(
          {
            fsym:
              exChangeBuy == null
                ? cryptoList?.resdata[0]?.mainnet_symbol
                : exChangeBuy?.selectedCrypto?.mainnet_symbol,
            tsyms:
              exChangeBuy == null
                ? currencyList?.resdata[0]?.symbol
                : exChangeBuy?.selectedCurrency?.symbol,
          },
          callback
        )
      );
    }
  }, [cryptoList, currencyList]);

  const callback = (response) => {
    if (response?.status === 200) {
      if (response?.data?.Response && response?.data?.Response == "Error") {
        setMarketPrice(0);
        setIsValid(false);
        return toastr.error(response?.data?.Message);
      } else {
        let info = response?.data?.[symbol];
        console.log("info", info, response?.data);
        setIsValid(true);
        setMarketPrice(info);
        let calculatedAmt = currencyValue / info;

        setCryptoValue(calculatedAmt);
      }
    }
  };

  /**
   * Used for calling api of get price
   */
  function callGetPrice(obj) {
    dispatch(
      getPrice(
        {
          ...params,
          fsym: obj?.selectedCrypto?.mainnet_symbol,
          tsyms: obj?.selectedCurrency?.symbol,
        },
        callback
      )
    );
  }

  /**
   * Used for calling api for get currency and get crypto
   */
  useEffect(() => {
    dispatch(getCurrency({ ...filters }));
    dispatch(getCrypto({ ...filters, _id: user?._id }));
  }, []);

  const hideCurrencyMod = (obj) => {
    if (obj == undefined) {
      setSelectedCurrency(currencyList?.resdata[0]);
      symbol = currencyList?.resdata[0]?.symbol;
    } else {
      setSelectedCurrency(obj?.selectedCurrency);
      symbol = obj?.selectedCurrency?.symbol;
    }
    setShowCurrency(false);
  };

  const hideCryptoMod = (obj) => {
    if (obj == undefined) {
      setSelectedCrypto(cryptoList?.resdata[0]);
    } else {
      setSelectedCrypto(obj?.selectedCrypto);
    }
    setFields({
      ...fields,
      walletAddress: obj?.selectedCrypto?.address,
    });
    setShowCrypto(false);
    symbol = selectedCurrency.symbol;
  };

  const handleCurrencyAmt = (e) => {
    if (/^[0-9]*\.?[0-9]*$/.test(e.target.value)) {
      if (marketPrice && e.target.value !== 0) {
        let finalAmt = e.target.value / marketPrice;
        setCryptoValue(finalAmt);
        setCurrencyValue(e.target.value);
      } else {
        setIsShowVerification(false);
      }
    }
  };

  const handleCryptoAmt = (e) => {
    if (/^[0-9]*\.?[0-9]*$/.test(e.target.value)) {
      if (marketPrice && e.target.value !== 0) {
        let finalAmt = e.target.value * marketPrice;
        setCryptoValue(e.target.value);
        setCurrencyValue(finalAmt);
      } else {
        setIsShowVerification(false);
      }
    }
  };

  const handleChange = (name) => (e) => {
    setFields((prev) => ({ ...prev, [name]: e.target.value }));
  };

  const handleCheckBox = (name) => (e) => {
    setFields((prev) => ({ ...prev, [name]: e.target.checked }));
  };

  const buyCrypto = (e) => {
    e.preventDefault();
    // let errorMessages = [];

    if (fields.termsCondition == false && fields.privacyPolicy == false) {
      toastr.error(t("agree_privacy_policy"));
      toastr.error(t("agree_terms_conditions"));
      return;
    }

    if (fields.termsCondition == false) {
      toastr.error(t("agree_terms_conditions"));
      return;
    }

    if (fields.privacyPolicy == false) {
      toastr.error(t("agree_privacy_policy"));
      return;
    }

    setBuyClicked(true);
    console.log("fileds =========>", fields);
    const isValidAddress = Web3.utils.isAddress(fields?.walletAddress?.trim());
    if (!isValidAddress) {
      toastr.error("Invalid Address");
      setBuyClicked(false);
      return;
    }

    // const callback = (response) => {
    //   if (response?.status == 200) {
    // toastr.success(t("address_verified"));
    setAddressVerified(true);
    openTransak();
    //   } else {
    //     setAddressVerified(false);
    //     return toastr.error(response?.response?.data?.error?.message);
    //   }
    // };
    // let param = {
    //   cryptoCurrency: selectedCrypto?.mainnet_symbol,
    //   network: "mainnet",
    //   walletAddress: fields?.walletAddress,
    // };

    // dispatch(verifyWallet(param, callback));
  };

  /**
   * Used for render the currency part of UI
   */
  const CurrencyDDL = () => {
    return (
      <div className="max-here">
        <Button className="btn-click" onClick={() => setShowCurrency(true)}>
          <img
            src={selectedCurrency && selectedCurrency?.icon}
            alt=""
            className="img-fluid"
          />
          <p>{selectedCurrency && selectedCurrency?.name}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
              fill="#000"
            />
          </svg>
        </Button>
      </div>
    );
  };

  /**
   * Used for render the crypto part of UI
   */
  const CryptoDDL = () => {
    return (
      <div className="max-here">
        <Button className="btn-click" onClick={() => setShowCrypto(true)}>
          <img
            src={selectedCrypto && selectedCrypto?.icon}
            alt=""
            className="img-fluid"
          />
          <p>{selectedCrypto && selectedCrypto?.name}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
              fill="#000"
            />
          </svg>
        </Button>
      </div>
    );
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 189 || e.keyCode === 187) {
      e.preventDefault();
    }
  };

  const handleBuy = () => {
    if (user?.Token && !isVerified) {
      toastr.error(t("complete_kyc_first"));
    } else if (!user?.Token) {
      toastr.error(t("login_to_access"), "left");
      navigate("/signin");
    } else {
      navigate("/buy");
      let data = {
        currencyValue,
        cryptoValue,
        selectedCrypto,
        selectedCurrency,
      };
      localStorage.setItem("exChangeBuy", JSON.stringify(data));
    }
  };

  let ele = document.getElementsByTagName("body");
  useEffect(() => {
    if (isAddressVerified || showCurrency || showCrypto) {
      ele[0].classList.add("mystyle");
    } else {
      ele[0].classList.remove("mystyle");
    }
  }, [isAddressVerified || showCurrency || showCrypto]);

  /**
   * Used for render the whole UI for Buy page
   */
  return (
    <Fade>
      <div>
        {showCurrency && (
          <CurrencyModal
            show={showCurrency}
            onHide={hideCurrencyMod}
            selectedCurrency={selectedCurrency}
            callGetPrice={callGetPrice}
            selectedCrypto={selectedCrypto}
            currencyList={currencyList?.resdata}
          />
        )}

        {showCrypto && (
          <CryptoModal
            show={showCrypto}
            onHide={hideCryptoMod}
            selectedCrypto={selectedCrypto}
            callGetPrice={callGetPrice}
            selectedCurrency={selectedCurrency}
            cryptoList={cryptoList?.resdata}
          />
        )}
      </div>

      <Processingmodal
        show={processingmodal}
        onHide={() => setProcessingmodal(false)}
        title="Request Submitted"
      />

      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container fluid className="container_postition">
          <Row>
            {/* <Col lg={3} md={6} sm={12} className="order-2 order-lg-1">
              <div className="Buystepone_stepper">
              
                <Newsteper/>
              </div>
            </Col> */}
            <Col lg={6} md={12} sm={12} className="order-1 order-lg-2 m-auto">
              <div className="buy_cryptoform position-relative text-start">
                <Form className="buy_crpto_form">
                  <div className="buy_form_head d-flex justify-content-between align-items-center">
                    <h2> {t("buy_crypto")}</h2>
                    {/* <p>
                      (1) <span>First Step</span>
                    </p> */}
                  </div>

                  <div className="Buy_btn_card mt-5">
                    <div className="form_liqudity">
                      <FormGroup className="input_here_wrap">
                        <div className="input_label desktop_form_label">
                          <p> {t("you_send")} </p>
                          <p>{selectedCurrency?.symbol}</p>
                        </div>

                        <div className="input_label mobile_form_label">
                          <p> {t("you_send")} </p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="number"
                            value={currencyValue}
                            onChange={handleCurrencyAmt}
                            min={"0"}
                            // onKeyDown={handleKeyDown}
                          />

                          <div className="input_label mobile_form_label">
                            <p>{selectedCurrency?.symbol}</p>
                          </div>
                          <CurrencyDDL />
                        </div>
                      </FormGroup>

                      <div
                        className="
                       text-start py-3"
                      >
                        {lang == "ar" ? (
                          <p>
                            {selectedCrypto?.mainnet_symbol} 1 ~{" "}
                            {selectedCurrency?.symbol}{" "}
                            <span> {marketPrice}</span>
                          </p>
                        ) : (
                          <p>
                            {marketPrice} {selectedCurrency?.symbol} ~ 1{" "}
                            <span>{selectedCrypto?.mainnet_symbol}</span>
                          </p>
                        )}

                        <div className="d-flex align-items-center justify-content-center"></div>
                      </div>

                      <FormGroup className="input_here_wrap">
                        <div className="input_label desktop_form_label">
                          <p>{t("you_get")}</p>
                          <p>{selectedCrypto?.mainnet_symbol}</p>
                        </div>

                        <div className="input_label mobile_form_label">
                          <p>{t("you_get")}</p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="number"
                            value={cryptoValue}
                            onChange={handleCryptoAmt}
                            min={"0"}
                            // onKeyDown={handleKeyDown}
                          />

                          <div className="input_label mobile_form_label">
                            <p>{selectedCrypto?.name}</p>
                          </div>
                          <CryptoDDL />
                        </div>
                      </FormGroup>
                    </div>
                    {isValid && isPath == "/buy" && (
                      <div>
                        {!isShowVerification && (
                          <Button
                            className="btn_sign_in w-100 mt-4 btn_theme"
                            // onClick={() => navigate("/buydetails")}
                            disabled={
                              currencyValue == "" || (cryptoValue == "" && true)
                            }
                            onClick={() => setIsShowVerification(true)}
                          >
                            {t("continue")}
                          </Button>
                        )}
                      </div>
                    )}

                    {isPath == "/" && isValid && (
                      <div>
                        <Button
                          className="btn_sign_in w-100 mt-4 btn_theme"
                          onClick={handleBuy}
                        >
                          {t("buy")}
                        </Button>
                      </div>
                    )}
                  </div>
                  {isShowVerification && (
                    <div>
                      <Col
                        lg={12}
                        className={`${
                          selectedPlatform == "transak" && "after_check"
                        } mt-4`}
                        onClick={() => setSelectedPlatform("transak")}
                      >
                        {/* <div className="check">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill={
                                selectedPlatform == "transak" ? "green" : "#ccc"
                              }
                              d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm4.2 8.3l-4.8 4.8c-.4.4-1 .4-1.4 0l-2.2-2.2c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l1.5 1.5l4.1-4.1c.4-.4 1-.4 1.4 0c.4.4.4 1 0 1.4z"
                            />
                          </svg>
                        </div> */}
                        <div className="transack d-flex justify-content-between align-items-center py-3">
                          <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                            <div className="trasack_icon me-2">
                              <img
                                src="/images/blueeth.png"
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <p className="m-0">Transak</p>
                          </div>
                          <div className="transaction_value">
                            <div className="d-flex align-items-center gap-2 justify-content-end">
                              <h4 className="text-truncate">
                                {currencyValue}{" "}
                              </h4>
                              <h4>{selectedCurrency?.symbol} </h4>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={12}
                        className={`${
                          selectedPlatform == "uniramp" && "after_check"
                        } mt-4 mb-4`}
                        onClick={() => setSelectedPlatform("uniramp")}
                      >
                        {/* <div className="check">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill={
                                selectedPlatform == "uniramp" ? "green" : "#ccc"
                              }
                              d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm4.2 8.3l-4.8 4.8c-.4.4-1 .4-1.4 0l-2.2-2.2c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l1.5 1.5l4.1-4.1c.4-.4 1-.4 1.4 0c.4.4.4 1 0 1.4z"
                            />
                          </svg>
                        </div> */}
                        <div className="transack d-flex justify-content-between align-items-center py-3">
                          <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                            <div className="trasack_icon me-2">
                              <img
                                src="/images/uniramp.png"
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <p className="m-0">Uniramp</p>
                          </div>
                          <div className="transaction_value">
                            <div className="d-flex align-items-center gap-2 justify-content-end">
                              <h4 className="text-truncate">
                                {currencyValue}{" "}
                              </h4>
                              <h4>{selectedCurrency?.symbol} </h4>
                            </div>
                          </div>
                        </div>
                      </Col>
                      {selectedPlatform !== "" && (
                        <>
                          <Col lg={12}>
                            <div className="wallet_Address">
                              <h3> {t("wallet_address")}</h3>

                              <FormGroup>
                                {console.log(fields)}
                                <Input
                                  type="text"
                                  name="walletAddress"
                                  id="walletAddress"
                                  value={fields?.walletAddress}
                                  onChange={handleChange("walletAddress")}
                                  readOnly
                                />
                              </FormGroup>

                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    value={fields?.termsCondition}
                                    onChange={handleCheckBox("termsCondition")}
                                  />{" "}
                                  {t("i_agree_with")}{" "}
                                  <a
                                    href={
                                      process.env.REACT_APP_WEBSITE_URL +
                                      "terms-conditions"
                                    }
                                    target="_blank"
                                  >
                                    {t("terms_conditions")}
                                  </a>
                                </Label>
                              </FormGroup>
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    value={fields?.privacyPolicy}
                                    onChange={handleCheckBox("privacyPolicy")}
                                  />{" "}
                                  {t("i_agree_with")}{" "}
                                  <a
                                    href={
                                      process.env.REACT_APP_WEBSITE_URL +
                                      "privacy-policy"
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {t("privacy_policy")}
                                  </a>
                                </Label>
                              </FormGroup>
                            </div>
                          </Col>

                          {selectedPlatform === "transak" && (
                            <Col lg={12}>
                              <div className="wallet_Address mt-4">
                                <Button
                                  className="btn_sign_in w-100 btn_theme"
                                  // onClick={() => setbuycryptomodone(true)}
                                  onClick={buyCrypto}
                                  disabled={
                                    isBuyClicked ||
                                    ((currencyValue == "" ||
                                      cryptoValue == "") &&
                                      true)
                                  }
                                >
                                  {t("buy")}
                                  {" " +
                                    cryptoValue +
                                    " " +
                                    selectedCrypto?.mainnet_symbol}
                                </Button>
                              </div>
                            </Col>
                          )}
                        </>
                      )}
                      {selectedPlatform === "uniramp" && (
                        <UnirampComponent
                          cryptoValue={cryptoValue}
                          currencyValue={currencyValue}
                          selectedCrypto={selectedCrypto}
                          fields={fields}
                          isBuy={true}
                        />
                      )}
                    </div>
                  )}
                </Form>
              </div>
            </Col>
            {/* 
            <Col lg={3} md={6} sm={12} className="order-3 order-lg-3 offset-lg-1">
              <Detailsbox />
            </Col> */}
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Buypagestepone;
